import endpoints from 'endpoints';
import { API_REQUEST_END } from 'actionTypes';

let initialState = {};
// Want to have an object where each of our endpoints is just false, to signify
// that it is not being fetched.
Object.keys(endpoints).forEach(key => (initialState[key] = {}));

// Handles errors that are tied to specific endpoints
export default function(state = initialState, action) {
  switch (action.type) {
    case API_REQUEST_END:
      let { apiAction, errors } = action;
      return {
        ...state,
        [apiAction]: errors,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/endpointErrorsReducer.js